import { network } from 'services/network';

export const getDataStories = ({ filter, pageParam, projectId }) => {
    const params = {
        filter: { filters: filter.filter.filters },
        paging: pageParam,
        projectId,
    };

    return network.post('api/bo/project/getDataStories', params).then((response) => {
        return response.data;
    });
};
